import instance from '../utils/axios';

class ConfigService {

    async getConfigByName(name) {
        return await instance.get('/crm/crmConfig/getCrmConfigByName?name='+name);
    }
}
export default new ConfigService();